import { useEffect } from "react";

export default function CurrencySwitcher({
    currency,
    setCurrency,
    usdSellRate,
    usdBuyRate,
    setUsdSellRate,
    setUsdBuyRate,
    /** Вузький рядок для шапки (наприклад, Виробництво) */
    compact = false,
    /** Додаткові класи на обгортку (наприклад, мобільне вирівнювання у хабі Виробництво) */
    className = "",
}) {

    useEffect(() => {
        const fetchRates = async () => {
            try {
                const res = await fetch("/api/exchange-rates");
                const data = await res.json();

                const usd = data.find(
                    (c) => c.currencyCodeA === 840 && c.currencyCodeB === 980
                );

                if (usd) {
                    setUsdBuyRate(usd.rateBuy || usd.rateCross);
                    setUsdSellRate(usd.rateSell || usd.rateCross);
                }
            } catch (e) {
                console.error("❌ Failed to load exchange rates", e);
            }
        };

        fetchRates();
    }, []);

    const ratesBlock = (
        <div className={compact ? "small text-muted text-nowrap" : ""}>
            {usdBuyRate && usdSellRate ? (
                <span className="text-muted">
                    USD: {usdBuyRate.toFixed(2)} / {usdSellRate.toFixed(2)}
                </span>
            ) : (
                <span className="text-muted">Завантаження курсу…</span>
            )}
        </div>
    );

    const switchBlock = (
        <div className="currency-switch d-flex align-items-center gap-2">
            <span>₴</span>
            <label
                className="switch"
                title="Перемкнути відображення сум: у гривнях (₴) або в доларах США ($) за курсом продажу"
            >
                <input
                    type="checkbox"
                    checked={currency === "USD"}
                    onChange={() =>
                        setCurrency(currency === "UAH" ? "USD" : "UAH")
                    }
                />
                <span className="slider" />
            </label>
            <span>$</span>
        </div>
    );

    if (compact) {
        return (
            <div
                className={`d-flex flex-column align-items-end gap-1 text-end ${className}`.trim()}
            >
                {ratesBlock}
                {switchBlock}
            </div>
        );
    }

    return (
        <div className="currency-holder d-flex justify-content-between align-items-center mb-3">
            <div>{ratesBlock}</div>
            {switchBlock}
        </div>
    );
}
